import { notification } from 'antd';
import React from 'react'
import { useNavigate } from 'react-router-dom';

const LogBookLoginRequired = (path) => {
    const navigate=useNavigate();
    notification.info({key:"loginRequired",message:"Login required",description:"Please Login Again",duration:3})
    localStorage.clear();
    setTimeout(() => {
        navigate(`/logbook/login?redirect=${path}`);
      }, 50);
}

export default LogBookLoginRequired
